/* eslint-disable */
export default {
  logging: 'Connessione...',
  logCall: 'Registra chiamata',
  editLog: 'Modifica registro',
  select: 'Seleziona un record corrispondente',
  OnHold: 'In attesa',
  Ringing: 'Chiamata in arrivo',
  CallConnected: 'Chiamata connessa',
  unknownUser: 'Utente sconosciuto',
  unknownNumber: 'Numero anonimo',
  unavailable: 'Non disponibile',
  viewDetails: 'Visualizza dettagli',
  addEntity: 'Crea nuovo',
  addLog: 'Registro',
  text: 'SMS',
  call: 'Chiamata',
  missedCall: 'Persa',
  inboundCall: 'In entrata',
  outboundCall: 'In uscita',
  answeredBy: 'Risposta fornita da',
} as const;

// @key: @#@"logging"@#@ @source: @#@"Logging..."@#@
// @key: @#@"logCall"@#@ @source: @#@"Log Call"@#@
// @key: @#@"editLog"@#@ @source: @#@"Edit Log"@#@
// @key: @#@"select"@#@ @source: @#@"Select a matching record"@#@
// @key: @#@"OnHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"Ringing"@#@ @source: @#@"Ringing"@#@
// @key: @#@"CallConnected"@#@ @source: @#@"Call Connected"@#@
// @key: @#@"unknownUser"@#@ @source: @#@"Unknown User"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"unavailable"@#@ @source: @#@"Unavailable"@#@
// @key: @#@"viewDetails"@#@ @source: @#@"View Details"@#@
// @key: @#@"addEntity"@#@ @source: @#@"Create New"@#@
// @key: @#@"addLog"@#@ @source: @#@"Log"@#@
// @key: @#@"text"@#@ @source: @#@"Text"@#@
// @key: @#@"call"@#@ @source: @#@"Call"@#@
// @key: @#@"missedCall"@#@ @source: @#@"Missed"@#@
// @key: @#@"inboundCall"@#@ @source: @#@"Inbound"@#@
// @key: @#@"outboundCall"@#@ @source: @#@"Outbound"@#@
// @key: @#@"answeredBy"@#@ @source: @#@"Answered by"@#@
